import React, { useState } from "react";
import {
  Axis,
  Chart,
  Tooltip,
  Interval,
  View,
  Line,
  Legend,
  getTheme,
  Interaction,
  registerInteraction,
} from "bizcharts";
import { PageHeader, Tabs, Row, Col, DatePicker, Table, Statistic } from "antd";

registerInteraction("element-link", {
  start: [
    { trigger: "interval:mouseenter", action: "element-link-by-color:link" },
  ],
  end: [
    { trigger: "interval:mouseleave", action: "element-link-by-color:unlink" },
  ],
});

const HistogramChart = (props) => {
  const theme = getTheme();

  const data = [
    { business_unit: "SpaceX", month: "Jan.", amount: 18.9 },
    { business_unit: "SpaceX", month: "Feb.", amount: 28.8 },
    { business_unit: "SpaceX", month: "Mar.", amount: 39.3 },
    { business_unit: "SpaceX", month: "Apr.", amount: 81.4 },
    { business_unit: "SpaceX", month: "May", amount: 47 },
    { business_unit: "SpaceX", month: "Jun.", amount: 20.3 },
    { business_unit: "SpaceX", month: "Jul.", amount: 24 },
    { business_unit: "SpaceX", month: "Aug.", amount: 35.6 },
    { business_unit: "Tesla", month: "Jan.", amount: 25.9 },
    { business_unit: "Tesla", month: "Feb.", amount: 15.8 },
    { business_unit: "Tesla", month: "Mar.", amount: 76.3 },
    { business_unit: "Tesla", month: "Apr.", amount: 54.4 },
    { business_unit: "Tesla", month: "May", amount: 32 },
    { business_unit: "Tesla", month: "Jun.", amount: 44.3 },
    { business_unit: "Tesla", month: "Jul.", amount: 73 },
    { business_unit: "Tesla", month: "Aug.", amount: 21.6 },
    { business_unit: "Bitcoin", month: "Jan.", amount: 45.9 },
    { business_unit: "Bitcoin", month: "Feb.", amount: 26.8 },
    { business_unit: "Bitcoin", month: "Mar.", amount: 87.3 },
    { business_unit: "Bitcoin", month: "Apr.", amount: 67.4 },
    { business_unit: "Bitcoin", month: "May", amount: 66 },
    { business_unit: "Bitcoin", month: "Jun.", amount: 72.3 },
    { business_unit: "Bitcoin", month: "Jul.", amount: 51 },
    { business_unit: "Bitcoin", month: "Aug.", amount: 43.6 },
    { business_unit: "Merck", month: "Jan.", amount: 12.4 },
    { business_unit: "Merck", month: "Feb.", amount: 23.2 },
    { business_unit: "Merck", month: "Mar.", amount: 34.5 },
    { business_unit: "Merck", month: "Apr.", amount: 99.7 },
    { business_unit: "Merck", month: "May", amount: 52.6 },
    { business_unit: "Merck", month: "Jun.", amount: 35.5 },
    { business_unit: "Merck", month: "Jul.", amount: 37.4 },
    { business_unit: "Merck", month: "Aug.", amount: 42.4 },
  ];

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const average = data.reduce((pre, item) => {
    const { month, monthAverageRain } = item;
    if (!pre[month]) {
      pre[month] = 0;
    }
    pre[month] += monthAverageRain;
    return pre;
  }, {});

  const averageData = Object.keys(average).map((key) => {
    return {
      month: key,
      averageRain: Number((average[key] / 2).toFixed(2)),
      name: "avg",
    };
  });

  const scale = {
    month: {
      sync: true,
    },
    averageRain: {
      min: 0,
      max: 100,
      alias: "Average",
    },
    monthAverageRain: {
      min: 0,
      max: 100,
    },
  };

  const colors = theme.colors10;

  /**
   * 图例开关状态
   */
  let legendMap = {};
  /**
   * 图表实例
   */
  let chartIns;

  return (
    <div>
      <h1
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: 18,
        }}
      >
        Monthly Sales by Business Unit
      </h1>
      <Chart height={400} padding="auto" data={props.data} autoFit>
        <Interval
          adjust={[
            {
              type: "stack",
            },
          ]}
          color="business_unit"
          position="month*amount"
        />
        <Axis
          name="amount"
          label={{
            formatter: (val) => numberWithCommas(val),
          }}
        />
        <Legend />
        <Tooltip shared>
          {(title, items) => {
            return (
              <div style={{ padding: 10 }}>
                {items.map((value, index) => {
                  // console.log(value);
                  return (
                    <div key={index + 1}>
                      <Row align="middle" justify="space-between">
                        <Col>
                          <Row>
                            <Col
                              style={{
                                backgroundColor: items[index].color,
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                marginRight: 12,
                              }}
                            />

                            <Col>
                              <span style={{ marginRight: 24 }}>
                                {value.data.business_unit} :
                              </span>
                            </Col>
                          </Row>
                        </Col>

                        <Col>
                          {"RM\xa0"}
                          {numberWithCommas(value.data.amount)}
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </div>
            );
          }}
        </Tooltip>
        <Interaction type="element-highlight" />
        <Interaction type="element-link" />
      </Chart>
      {/* <Chart
        height={400}
        padding={[50, 60]}
        scale={scale}
        data={data}
        autoFit
        onGetG2Instance={c => (chartIns = c)}
      >
        <Tooltip shared />
        <Interval
          adjust={[
            {
              type: "dodge",
              marginRatio: 0
            }
          ]}
          color={["name", colors]}
          position="month*monthAverageRain"
        />
        <Axis name="monthAverageRain" position="left" />
        <View data={averageData} scale={scale} padding={0}>
          <Axis name="averageRain" position="right" />
          <Line position="month*averageRain" color={colors[2]} />
        </View>
        <Legend
          custom={true}
          items={[
            {
              name: "Merck",
              value: "merck",
              marker: {
                symbol: "square",
                style: { fill: colors[0] }
              }
            },
            {
              name: "SpaceX",
              value: "spaceX",
              marker: {
                symbol: "square",
                style: { fill: colors[1] }
              }
            },
            {
              name: "Average",
              value: "avg",
              marker: {
                symbol: "hyphen",
                style: { stroke: colors[2], lineWidth: 2 }
              }
            }
          ]}
          onChange={ev => {
            const { item } = ev;
            const { value } = item;
            const checked = !item.unchecked;
            // 设置图例项状态
            legendMap[value] = checked;
            if (value === "avg") {
              // 通过filter控制元素显示隐藏
              const view = chartIns.views[0];
              view.filter("name", val => {
                return legendMap[val];
              });
              // 重新渲染，触发filter
              view.render(true);
            } else {
              // 通过filter控制元素显示隐藏
              chartIns.filter("name", val => {
                return legendMap[val] !== false;
              });
              // 重新渲染，触发filter
              chartIns.render(true);
            }
          }}
        />
      </Chart> */}
    </div>
  );
};

export default HistogramChart;
